import api from '@/api/axios';
import { logError } from '@/utils/logHandling';
import {
  documentDirectory,
  writeAsStringAsync,
  EncodingType,
} from 'expo-file-system/legacy';
import { isAvailableAsync, shareAsync } from 'expo-sharing';
import { Platform } from 'react-native';

const API_DATA = '/api/users/users-data';

const fetchTherapistData = async () => {
  const { data } = await api.get(API_DATA);
  return JSON.stringify(data, null, 2);
};

const formatFileName = () => {
  const d = new Date();
  const date = d.toISOString().split('T')[0];
  return `personenbezogene-daten-${date}.json`;
};

export const exportTherapistData = async () => {
  if (Platform.OS === 'web') {
    return await fetchAndDownloadWeb();
  } else {
    return await fetchAndDownloadTablet();
  }
};

const fetchAndDownloadWeb = async () => {
  try {
    const data = await fetchTherapistData();

    const blob = new Blob([data], { type: 'application/json' });

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = formatFileName();
    a.click();

    URL.revokeObjectURL(url);
    return Promise.resolve({ success: true });
  } catch (err) {
    logError('Error downloading JSON:', err);
    return Promise.resolve({ success: false });
  }
};

const fetchAndDownloadTablet = async () => {
  try {
    const data = await fetchTherapistData();

    const fileUri = documentDirectory + formatFileName();

    await writeAsStringAsync(fileUri, data, {
      encoding: EncodingType.UTF8,
    });

    if (await isAvailableAsync()) {
      await new Promise((resolve) =>
        setTimeout(async () => resolve(await shareAsync(fileUri)), 300),
      );

      return Promise.resolve({ success: true });
    } else {
      logError('Sharing is not available on this platform');
      return Promise.resolve({ success: false });
    }
  } catch (e) {
    logError('Error:', e);
    return Promise.resolve({ success: false });
  }
};
